<template>
	<div class="tabs-container">
		<div class="tabs">
			<router-link
				v-for="t in matchedTabs"
				:key="t.label"
				v-bind="t"
				class="tab"
			>
				<p class="tab__text">{{ t.label }}</p>
				<p v-if="t.badge" class="tab__badge">{{ t.badge }}</p>
			</router-link>
		</div>
		<card>
			<slot />
		</card>
	</div>
</template>

<script>
import Card from '@/components/shared/Card'

export default {
	name: 'router-tabs',
	props: {
		tabs: {
			type: Array,
			validator: v => v.every(t => t.label && t.to)
		},
		matchActive: {
			type: Function,
			default: () => tab => tab.to.path === this.$route.path
		}
	},
	computed: {
		matchedTabs() {
			return this.tabs.map(t => ({
				...t,
				class: { match: this.matchActive(t) }
			}))
		}
	},
	methods: {
		classes(tab) {
			// Allow defining custom route match function
			return { match: this.matchActive(tab) }
		}
	},
	components: {
		Card
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/vars';
@import '~scss/components';

.tabs {
	display: flex;
	width: 100%;
	overflow-x: auto;

	.tab {
		display: flex;
		padding: 1.25rem 2.5rem;
		background-color: $blue-73;
		text-decoration: none;

		&.match,
		&:not(.match):hover {
			background-color: $blue-48;
		}

		&:focus {
			outline: none;
			box-shadow: inset 0 0 0 2px $yellow-97;
		}

		&__text {
			color: $white;
			margin: 0;
			font-size: 0.875rem;
			white-space: nowrap;
		}

		&__badge {
			@include badge(1.5rem);
			margin: 0 -0.5rem 0 1rem;
		}
	}
}
</style>
